export enum GlobalSearchModuleSearch {
    MODULE,
    FIELD,
    VALUE
}

export enum ProductSubModule {
    Inventory = 1,
    Service,
    NonInventory,
    Bundle,
    Kit
}

export enum PurchaseSubModule {
    Purchas_eOrder = 1,
    Item_Receipt,
    Bill,
    Bill_Payment,
    Vendors,
    Vendor_Return,
    Vendor_Credit
}
